import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpParams,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class WorkflowBusinessFunctionsListInterceptor
  implements HttpInterceptor
{
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          if (
            request.method === 'GET' &&
            request.url.includes(
              '/api/approval-service/client-api/v2/policy-assignments/approvable-business-functions'
            ) &&
            event.status === 200
          ) {
            const activeFunctions =
              event.body.approvableBusinessFunctions.filter(
                (func: any) =>
                  !(
                    func.function === 'Manage Self-approve Permissions' &&
                    func.resource === 'Entitlements'
                  )
              );
              console.log('activeFunctions', activeFunctions)
            return event.clone({ body: { activeFunctions } });
          }
        }
        return event;
      })
    );
  }
}
